module.exports = __webpack_public_path__ + "view/img/foot.e8d92b2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/foot.png
// module id = JaU/
// module chunks = 13